import styled from 'styled-components';

export default styled.div`
  .action-buttons-wrapper {
      .button {
          margin: 0;
      }
      
      margin-bottom: 10px;
      display: flex;
      justify-content: flex-end;
      gap: 10px;
  }

  .pagination-wrapper {
      display: flex;
      justify-content: center;

      .MuiButtonBase-root {
          line-height: 1;
      }

      .MuiPaginationItem-root {
          display: flex;
          align-items: center;
          justify-content: center;
      }
  }
`;